


<template>
	<div>
		<panel title="Вывод средств">
			<template slot="beforeBody">

			</template>
			<!-- BEGIN panel -->
			<div class="card  border-0 mb-3">


				<h3>Выплаты:</h3>

				<table class="table table-hover">
					<thead>
						<tr>
							<th>
								<h5>Аккаунт</h5>
							</th>
							<th>
								<h5>Дата</h5>
							</th>
							<th>
								<h5>Cтатус</h5>
							</th>
							<th>
								<h5>Кошелек</h5>
							</th>
							<th>
								<h5>Ссылка</h5>
							</th>
							<th>
								<h5>Коммент</h5>
							</th>
							<th>
								<h5>Авто</h5>
							</th>
							<th>
								<h5>Подтвердить</h5>
							</th>
							<th>
								<h5>Отменить</h5>
							</th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="payout in payouts" v-bind:key="payout.id" style="vertical-align: middle;">
							<td>
								<img @click="$router.push(`/admin_user_show/${payout.user.id}`);"
									:src="`/images/avatar/${payout.user.avatar}`" width="50" height="50"
									class="user-avatar mb-3" alt="">
								<div><b>{{ payout.user.name.substring(0, 6) }}</b></div>
								<div class="small">{{ payout.user.email_verified_at.replace('Подтвержден',
										'').replace('Email не подтвержден', 'не подв.')
								}}</div>

							</td>
							<td>
								{{ payout.created_at }}<br>
								ID:<b>{{ payout.user.id }}</b><br>
								Заработано:<b class="text-green">{{ payout.user.balance_earn }}</b><br>
								Рефералы:<b class="text-green">{{ payout.user.balance_ref }}</b><br>
								Призовые:<b class="text-green">{{ payout.user.balance_prise }}</b><br>
								Мультиак:<b class="text-red">{{ payout.multi }}</b>
							</td>
							<td class="text-center"
								v-html="`<div class='pt-1'>${payout.status}</div><div class='pt-2'><b>${payout.sum}</b></div><div class='pt-2'>${payout.created_at}</div>`">
								<br>
							</td>
							<td>
								<div v-if="payout.wallets.includes(payout.wallet)">
									<b class="text-teal">{{ payout.wallet }}</b>
								</div>
								<div v-else>
									<b class="text-red-700">{{ payout.wallet }}</b>
								</div>
								<div class="pt-2">
									<div class="small" v-for="(wallet, index)  in  payout.wallets" :key=index>
										{{ wallet }}
									</div>
								</div>

							</td>
							<td>
								<a :href="payout.link" target="_blank">Ссылка</a>
							</td>
							<td>
								{{ payout.comment }}
							</td>
							<td>
								<button class="btn btn-indigo me-2" @click="autoPay(payout.id)">Авто</button>
							</td>
							<td>
								<button class="btn btn-primary me-2"
									@click="statusUpdate(payout.id, { status: 'DONE' })">Выплатить</button>
							</td>
							<td>
								<button class="btn btn-danger"
									@click="statusUpdate(payout.id, { status: 'CANCELED' })">Отказать</button>
							</td>
						</tr>
						<tr v-if="!payouts.length">
							<td colspan="10" align="center">У вас нет заявок на вывод </td>
						</tr>
					</tbody>
				</table>

			</div>
			<!-- END panel -->
		</panel>
	</div>
</template>


<script>
	import HTTP from "../http";
	import { show_error, show_message } from "../message";


	export default {

		data() {
			return {
				loading: false,
				errors: null,
				title: null,
				data: {
					sum: 0,
					wallet: 0,
				},
				payouts: []
			};
		},

		created() {
			this.fetchData()
		},

		methods: {
			autoPay(id) {
				this.$insProgress.start();
				this.loading = true;
				HTTP()
					.post("/auto_pay/", { id })
					.then((resp) => {
						console.log(resp.data)
						show_message(this.$notify, JSON.stringify(resp.data))
					})
					.catch((error) => {
						show_error(this.$notify, this.$refs.form, error.response.data)
					})
					.finally(() => {
						this.loading = false;
						this.$insProgress.finish();
					});
			},

			statusUpdate(id, data) {
				let comment = prompt('Комментарий', '');
				data.comment = comment

				this.$insProgress.start();
				this.loading = true;
				HTTP()
					.put("/admin_payout/" + id, data)
					.then((resp) => {
						console.log(resp)
						show_message(
							this.$notify,
							resp.data
						);
						this.data = {
							sum: 0,
							wallet: 0,
						}
						setTimeout(() => { this.fetchData() }, 500);
					})
					.catch((error) => {
						show_error(this.$notify, this.$refs.form, error.response.data)
					})
					.finally(() => {
						this.loading = false;
						this.$insProgress.finish();
					});
			},
			fetchData() {
				this.loading = true;
				this.$insProgress.start();

				HTTP()
					.get(`/admin_payout`)
					.then((resp) => {
						console.log('resp', resp)
						this.payouts = resp.data;
					})
					.catch((error) => {
						show_error(this.$notify, this.$refs.form, error.response.data)
					})
					.finally(() => {
						this.loading = false;
						this.$insProgress.finish();
					});
			},

		}
	}

</script>


<style>
.task-href {
	cursor: pointer;
	text-decoration: none;
	color: var(--bs-body-color);
}

.task-href:visited {
	color: var(--bs-body-color);
}

.task-href:hover {
	color: var(--bs-body-color);
}
</style>

